import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import Paper from '@mui/material/Paper';
import { useState } from 'react';
import { StyledTableCell, StyledTableRow, styles } from '../../style/style';
import { FormattedMessage } from "react-intl";

export default function EventHistory(eventHistoryList) {

    const [eventHistory] = useState(eventHistoryList.eventHistoryList)

    const header = [
        'orderdetailcomponents.orderHistoryTable.event',
        'orderdetailcomponents.orderHistoryTable.eventDate'
    ]

    const headerDefaults = ['Event', 'Event Date']

    return (
        <Box>
            <TableContainer component={Paper}>
                <Table id="eventHistoryTable">
                    <TableHead>
                        <TableRow>
                            {header.map((headerItem, index) => (
                                <TableCell id={headerItem+"Header"} key={index} sx={styles.TableCellHeader}><FormattedMessage id={headerItem} defaultMessage={headerDefaults[index]} /></TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    {eventHistory.length !== 0 ? (
                        <TableBody>
                            {eventHistory.map((event, index) => (
                                <StyledTableRow key={index}>
                                    <StyledTableCell sx={styles.OrderDetailOptionTableCell}>
                                        
                                        {event.curEventCd} - <FormattedMessage
                                            id={`eventcode.${event.curEventCd}`}
                                            defaultMessage="Event Code Description Unavailable" />

                                            
                                    </StyledTableCell>
                                    <StyledTableCell sx={styles.OrderDetailOptionTableCell}>{event.curEventDate}</StyledTableCell>
                                </StyledTableRow >
                            ))}
                        </TableBody>
                    ) : (
                        <TableBody>
                            <StyledTableRow>
                                <StyledTableCell >
                                    <FormattedMessage id='orderdetailcomponents.orderOptionsTable.noEventsToDisplay' defaultMessage='No Events to Display' />
                                </StyledTableCell>
                            </StyledTableRow >
                        </TableBody>
                    )}
                </Table>

            </TableContainer>
        </Box >

    )
}
